// const server = "http://localhost";
// const domain = "localhost";
// const port = 9666;
const serverImg = 'https://fosovo.nbg1.your-objectstorage.com/public';
const server = "https://apifosovo.mansolutions.app";
const port = 443;
const domain = "fosovo.mansolutions.app";
export { server, port, domain, serverImg };
